import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { default: String }

  connect() {
    const hash = window.location.hash.replace("#", "")
    const ownTabs = this.tabTargets.map((t) => t.dataset.tab)
    const initial = (ownTabs.includes(hash) && hash) || this.defaultValue || ownTabs[0]
    if (initial) this.show(initial)
  }

  select(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.show(tab)

    if (!this.element.closest("[data-controller='tabs'] [data-tabs-target='panel']")) {
      history.replaceState(null, "", `#${tab}`)
    }
  }

  show(name) {
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle("active", tab.dataset.tab === name)
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tab !== name
    })
  }
}
